import $ from "jquery";

const socialLinkObject = {
    variables: {
        socialLinks: $(".generic__links"),
        url: window.location.href,
    },
    methods: {
        redirectLink: function (label) {
            var currentPageUrl = (window.location.href);
            var pageTitle = $(document).prop("title");

            var shareUrl;

            switch (label) {
                case "icon facebook":
                    shareUrl = `https://www.facebook.com/share.php?u=${currentPageUrl}&text=${pageTitle}`;
                    break;
                case "icon linkedin":
                    shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${currentPageUrl}&text=${pageTitle}`;
                    break;
                case "icon xlogo":
                    shareUrl = `https://twitter.com/share?url=${currentPageUrl}&text=${pageTitle}`;
                    break;
                case "icon whatsapp":
                    shareUrl = `https://wa.me/?text=${currentPageUrl}&message=${pageTitle}`;
                    break;
                case "link":
                    navigator.clipboard
                        .writeText(currentPageUrl)
                        .then(function () {
                            alert("Page URL copied to clipboard: " + currentPageUrl);
                        })
                        .catch(function (error) {
                            alert("Failed to copy", +  error);
                        });
                    shareUrl = '';

                    break;
                default:
                    return;
            }
            return shareUrl;
        },
        removeDivider: function(){
            $(".social__share__wrapper").children("div[class=divider]:last").remove();
        },
        // Give every share icon its real href at load (it used to be set only on
        // click), so the links are crawlable (SEO: crawlable-anchors). The click
        // handler below still sets the same URL. The share bar's YouTube icon has
        // no share URL, so it gets the site's YouTube channel link from the
        // header/footer; the "link" (copy URL) icon is left as it is.
        setShareHrefs: function(){
            var youtubeUrl = $("a.header__socials--link[icon='youtube'], a.footer__social__links--link[icon='youtube']").first().attr("href");
            $(".socialshare .generic__links").each(function () {
                var $link = $(this);
                if ($link.attr("href")) {
                    return;
                }
                var label = ($link.attr("data-label") || "").toLowerCase().replace(/[^a-z0-9\s-]/g, "");
                if (label === "icon youtube") {
                    if (youtubeUrl) {
                        $link.attr({ href: youtubeUrl, rel: "noopener noreferrer" });
                    }
                    return;
                }
                if (label === "link") {
                    return;
                }
                var shareUrl = socialLinkObject.methods.redirectLink(label);
                if (shareUrl) {
                    $link.attr("href", encodeURI(shareUrl));
                }
            });
        },

        dataLayerObj : function(e) {
                var obj = {
                    'articleName' : "",
                    'blogCategory' : "",
                    'blogPageCategory' : "",
                    'buttonText' : e.currentTarget.innerText.replace(/\n/g, '').trim(),
                    'pageSection' : "Social Share",
                    'pageType' : document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? socialLinkObject.variables.url.includes("blog") ? "Blogs" : socialLinkObject.variables.url.substring(socialLinkObject.variables.url.indexOf(".com/"), socialLinkObject.variables.url.lastIndexOf('/')  === ".com") && !socialLinkObject.variables.url.substring(socialLinkObject.variables.url.indexOf(".com/"), socialLinkObject.variables.url.length-1).includes('/') ? "Home" : "Other Pages" : "Blog Details Page",
                    'planOption' : "",
                    'productCategory' : "",
                    'productName' : "",
                    'question' : "",
                    'searchTerm' : "",
                    'videoTitle' : "",
                    'bannerName' : "",
                    'bannerType' : ""
                };
                return obj;
            }
    },
    init:function(){
         this.methods.removeDivider();
         this.methods.setShareHrefs();
    }
};

$(".socialshare .generic__links").on("click", function (e) {
    let label = $(this).attr("data-label");
    if(label != null) {
      label = label.toLowerCase().replace(/[^a-z0-9\s-]/g, "");
     if (socialLinkObject.methods.redirectLink(label) && socialLinkObject.methods.redirectLink(label) !== '') {
        let redirectUrl = encodeURI(socialLinkObject.methods.redirectLink(label));
        $(this).attr("href", redirectUrl);
     }

     if (label === 'link' && socialLinkObject.methods.redirectLink(label) === '') {
        $(this).removeAttr('href');
     }
    if(label!='icon youtube')
    {
      let obj = socialLinkObject.methods.dataLayerObj(e);
     if(obj && typeof obj == "object") {
      createDataLayer("SocialMediaShare", obj);
     }
    }
   }
});

socialLinkObject.init();

